<template>
    <div class="c-header" v-bind:class="{'c-header--brand':brand}">
        <div class="c-header__content">
            <a href="/">
                <img src="@/assets/images/krotoski_logo_grey.svg" alt="Grupa Krotoski">
            </a>
            <span v-if="brand">
                <img :src="brand.logo" :alt="brand.name" class="c-header__brandLogo">
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props:['brand']
}
</script>
<style lang="scss">
    .c-header{
        max-width: 1630px;
        padding: 3rem 1rem;
        margin: 0 auto;
        &__content{
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        &--brand{
            .c-header__content{
                justify-content: space-between;
            }
        }
        &__brandLogo{
            max-height: 117px;
            width: 100%;
            max-width: 260px;
            @media(max-width:780px){
                max-height: 78px;
            }
        }
        @media(max-width:780px){
            padding: 1rem;
            img{
                max-width: 25vw;
            }
        }
    }
</style>
